<div style="background-color: #f9f9f9" id="payIn4Popup">
  <div class="modal-window_close" (click)="close()">
    <span class="icon icon_cross-light"></span>
  </div>
  <div id="imgDiv">
    <img style="height: 3.1em" src="../../../../../assets/images/pay-in-4-logo-op-2@3x.png" loading="lazy" />
  </div>
  <div class="topText">Loan Payment Process</div>
  <ul class="account-list">
    <li>
      Split your payments into <span class="font-weight-bold">4 interest-free</span><br />installments over 6
      weeks.
    </li>
    <li>
      Pay your first loan payment of
      <span class="font-weight-bold">${{ amount | number: '1.2' }}</span> via<br />
      debit card when you tap “Pay My Dentist”.
    </li>
    <li><span class="font-weight-bold">No hard credit check.</span></li>
    <li>Delinquencies will be reported to credit bureau.</li>
  </ul>
  <div style="margin-top: 2em; color: #444">
    <img class="pie-chart" src="../../../../../assets/images/PayIN4.png" loading="lazy" />
    <div class="d-flex j-content-center">
      <span
        [class.pie-chart__text_bold_short]="amount.toString().length <= 2"
        class="pie-chart__text pie-chart__text_bold"
        >${{ amount | number: '1.2' }}<br />
        Due Today</span
      ><span
        [class.pie-chart__text_short]="amount.toString().length > 2"
        class="pie-chart__text pie-chart__text_margin"
        >${{ amount | number: '1.2' }}<br />
        Week 2</span
      ><span
        [class.pie-chart__text_short]="amount.toString().length > 2"
        class="pie-chart__text pie-chart__text_margin"
        >${{ amount | number: '1.2' }}<br />
        Week 4</span
      ><span style="margin-right: 0.1em" class="pie-chart__text"
        >${{ amount | number: '1.2' }}<br />
        Week 6</span
      >
      <!-- <img class='pie-chart' src="../../../../../assets/images/pie-chart@4.png" loading="lazy"><span class="border-solid"></span><img class='pie-chart' src="../../../../../assets/images/pie-chart2@4.png"><span class="border-solid"></span><img class='pie-chart' src="../../../../../assets/images/pie-chart3@4.png"><span class="border-solid"></span><img class='pie-chart' src="../../../../../assets/images/pie-chart4@4.png"> -->
    </div>
  </div>
</div>
